/* global axios */
import ApiClient from '../ApiClient';

// Tom de voz + diretrizes gerais do Capitao (por conta). Recurso singular.
class CalibracaoAPI extends ApiClient {
  constructor() {
    super('fandata/calibracao', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  // Save parcial: encaminha só os campos enviados (tom/diretrizes/handoff,
  // roteamento_auto/roteamento_map, alerta_fila_limite). O controller ignora o que não vier.
  update(payload) {
    return axios.patch(this.url, payload);
  }

  // T-218: o consumo de IA dia a dia, no período escolhido na tela.
  consumo({ since, until } = {}) {
    return axios.get(`${this.url}/consumo`, { params: { since, until } });
  }
}

export default new CalibracaoAPI();
